var map = {
	"./breadcrumbs": [
		85557,
		5557
	],
	"./breadcrumbs.ts": [
		85557,
		5557
	],
	"./student": [
		92668,
		2668
	],
	"./student/": [
		92668,
		2668
	],
	"./student/index": [
		92668,
		2668
	],
	"./student/index.ts": [
		92668,
		2668
	],
	"./student/student": [
		96197,
		6197
	],
	"./student/student.tsx": [
		96197,
		6197
	],
	"./teacher": [
		9071,
		9071
	],
	"./teacher/": [
		9071,
		9071
	],
	"./teacher/index": [
		9071,
		9071
	],
	"./teacher/index.ts": [
		9071,
		9071
	],
	"./teacher/teacher": [
		97879,
		7879
	],
	"./teacher/teacher.tsx": [
		97879,
		7879
	],
	"./utils": [
		51581,
		1581
	],
	"./utils.ts": [
		51581,
		1581
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83235;
module.exports = webpackAsyncContext;